import booleanColumn from '../column-helpers/boolean/boolean-component';
import percentFullColumn from '../column-helpers/percent_full/percent-full-component';

export const fileServersColumnConfig = {
  enabled: {
    label: 'Enabled',
    width: 90,
    columnRendererComponent: booleanColumn,
    shown: false,
    type: 'boolean',
    priority: 1,
  },
  isMain: {
    label: 'Main',
    width: 90,
    columnRendererComponent: booleanColumn,
    shown: false,
    type: 'boolean',
    priority: 2,
  },
  name: {
    label: 'Name',
    width: 220,
    shown: true,
    type: 'text',
    priority: 3,
  },
  identifier: {
    label: 'ID',
    width: 110,
    shown: false,
    type: 'text',
    priority: 4,
  },
  ip: {
    label: 'IP Address',
    width: 110,
    shown: false,
    type: 'text',
    priority: 5,
  },
  proxy: {
    label: 'Proxy IP Address',
    width: 150,
    shown: false,
    type: 'text',
    path: 'proxyList[0].ip',
    priority: 6,
  },
  status: {
    label: 'Status',
    width: 110,
    shown: true,
    type: 'text',
    priority: 7,
  },
  percentFull: {
    label: 'Usage',
    width: 110,
    entityColumn: true,
    columnRendererComponent: percentFullColumn,
    shown: true,
    type: 'text',
    priority: 8,
  },
};
